import styled from 'styled-components'

const FeatureBox = styled.div`
  margin-bottom: 20px;
`

export default FeatureBox
